<template>
  <div>
    <div class="flex modal-form__titles">
      <h3>{{ $t('vue2.createusers.name') }}*</h3>
      <h3>{{ $t('vue2.createusers.login_options') }} -
        <span class="text-grey italic font-small">{{ $t('vue2.createusers.can_be_added_later') }}</span>
      </h3>
    </div>
    <div class="modal-form-group" v-for="(user, key) in users" :class="{'hoverDanger': user.userHoverDanger}">
      <div class="create-form">
        <div class="create-form__name">
          <input type="text"
                 :placeholder="$t('vue2.createusers.placeholder_name')"
                 class="namefield"
                 @input="checkAllForText($event.target.value, 'username', key)"
                 :class="{'inputError': !user.nameIsValid}"
                 @blur="validate(user, key)"
                 @focus="unValidate(user, key)"/>
          <span class="error-text" v-if="!user.nameIsValid">{{ $t('vue2.createusers.must_be_added') }}</span>
        </div>
        <div class="create-form__login">
          <div v-if="country.toLowerCase() === 'dk'">
            <input type="text"
                   placeholder="uni-login"
                   class="UniLogin"
                   :class="{'inputPristine': user.unilogin.length < 1}"
                   @blur="validate(user, key)"
                   @focus="unValidate(user, key)"
                   @input="checkAllForText($event.target.value, 'unilogin', key)" />
          </div>
          <div v-if="country.toLowerCase() === 'no'">
            <input type="text"
                   placeholder="feide"
                   class="feide"
                   :class="[{'inputPristine': user.feide.length < 1}, {'input--error': getIsUserWithSameFeide(user)}]"
                   @blur="validate(user, key)"
                   @focus="unValidate(user, key)"
                   @input="checkAllForText($event.target.value, 'feide', key)"/>
            <p class="error-text" v-if="getIsUserWithSameFeide(user)">
              {{ $t('vue2.createusers.feide_is_already_used_for') }} {{ userWithSameFeide.name }}</p>
          </div>
          <div>
            <input type="text"
                   :placeholder="$t('vue2.createusers.mail')"
                   :class="[{'inputError': !user.validEmail}, {'inputPristine': user.email.length < 1}]"
                   @blur="validateEmail(user, $event.target.value, key)"
                   @keyup="checkEmailAndAllForText(user, $event.target.value, key)"
                   @focus="unValidate(user, key)"
            />
            <span class="error-text" v-if="!user.validEmail">{{ $t('vue2.createusers.email_error_text') }}</span>
          </div>
        </div>
      </div>
      <div class="delete__user"
           @click="removeUser(user)"
           @mouseenter="setHoverDanger(key)"
           @mouseleave="removeHoverDanger(key)">
        <span class="icon-cross2"></span>
      </div>
    </div>
    <div>
      <div class="add-more-button"
           @click="pushNewUser">
            <span class="plus--icon">
              +
            </span>
        <span class="add-more-button__text"> {{ $t('vue2.createusers.add_more') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    country: {
      default: 'dk'
    },
    pushname: {
      default: ''
    }
  },
  data () {
    return {
      users: [],
      usersWithText: [],
      userWithSameFeide: null,
      debounceTimer: null
    }
  },
  computed: {
    allUsers () {
      return this.$store.state.allUsers
    }
  },
  methods: {
    getIsUserWithSameFeide (user) {
      return this.userWithSameFeide && this.userWithSameFeide.email === user.feide
    },
    pushNewUser () {
      this.users.push({
        name: '',
        nameIsValid: true,
        unilogin: '',
        feide: '',
        email: '',
        validEmail: true,
        userHoverDanger: false
      })
      if (this.users.length > 4) {
        setTimeout(() => {
          this.scrollInDiv()
        }, 0)
      }
    },
    setHoverDanger (idx) {
      this.users[idx].userHoverDanger = true
    },
    removeHoverDanger (idx) {
      this.users[idx].userHoverDanger = false
    },
    removeUser (user) {
      this.users.splice(this.users.indexOf(user), 1)
      this.checkAllForText()
    },
    scrollInDiv () {
      var objDiv = document.querySelector('.modal-body')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    validateEmail (user, email, key) {
      if (email.length < 1) {
        this.users[key].validEmail = true
      } else {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        this.users[key].validEmail = re.test(String(email).toLowerCase())
        if (re.test(String(email).toLowerCase())) {
          this.validate(user, key)
        }
      }
    },
    checkEmailAndAllForText (user, email, userIdx) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.users[userIdx].email = email
        this.checkAllForText()
        if (email.length < 1) {
          this.users[this.users.indexOf(user)].validEmail = true
        }
      }, 250)
    },
    checkAllForText (text, theType, userIdx) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        if (theType === 'username') {
          this.users[userIdx].name = text
          this.$emit('onNameInput', text)
        }
        if (theType === 'unilogin') {
          this.users[userIdx].unilogin = text
        }
        if (theType === 'feide') {
          this.users[userIdx].feide = text
          this.checkIfAlreadyUsed(text, 'feide', userIdx)
        }
        this.usersWithText = []
        for (let i = 0; i < this.users.length; i++) {
          if (this.users[i].name.length > 0) {
            this.usersWithText.push(this.users[i])
          }
        }
        this.$emit('editedUsers', this.usersWithText)
        if (this.usersWithText.length === this.users.length) {
          this.pushNewUser()
        }
      }, 300)
    },
    checkIfAlreadyUsed (loginId, theType) {
      if (theType === 'feide') {
        let user = this.allUsers.filter(user => user.email === loginId)
        if (user.length > 0) {
          this.userWithSameFeide = user[0]
        } else {
          this.userWithSameFeide = null
        }
      }
    },
    validate (user, key) {
      if (user.name.length >= 0) {
        this.users[key].nameIsValid = true
      }
      if (user.email.length > 0 && user.name.length < 1) {
        this.users[key].nameIsValid = false
      }
      if (this.country.toLowerCase() === 'dk') {
        if (user.unilogin.length > 0 && user.name.length < 1) {
          this.users[key].nameIsValid = false
        }
      } else if (this.country.toLowerCase() === 'no') {
        if (user.feide.length > 0 && user.name.length < 1) {
          this.users[key].nameIsValid = false
        }
      }
    },
    unValidate (user, key) {
      this.users[key].nameIsValid = true
    }
  },
  mounted () {
    var i = 0
    if (this.pushname.length > 1) {
      this.users.push({
        name: this.pushname,
        nameIsValid: true,
        unilogin: '',
        feide: '',
        email: '',
        validEmail: true,
        userHoverDanger: false
      })
      this.checkAllForText()
      i = 2
    }
    for (i; i < 3; i++) {
      /* Push 3 input-fields users */
      this.pushNewUser()
      this.$emit('editedUsers', this.usersWithText)
      setTimeout(() => {
        document.querySelector('.namefield').focus()
      }, 100)
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.create-form {
  display: flex;
  width: 100%;
}

.modal-form-group {
  display: flex;
  align-items: center;
  padding: 7px 20px 5px;
  margin: 0;
  transition: all 0.2s;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #999
}

.modal-form__titles {
  padding: 0 20px;
  margin-bottom: 5px;
}

.create-form__name,
.modal-form__titles > h3:first-child {
  width: 43%;
}

.create-form__login,
.modal-form__titles > h3:nth-child(2) {
  width: 57%;
}

.modal-form__titles > h3:nth-child(2) {
  padding-right: 20px;
}

.create-form {
  width: 100%;
  margin-top: 10px;
}

.create-form:first-child {
  margin-top: 0;
}

.create-form:last-child {
  border-bottom: 0 !important;
}

.create-form > div {
  margin: 0 10px 0 0;
  display: flex;
}

.create-form > div label {
  font-size: 10px;
}

.create-form__name {
  flex-direction: column;
}

.create-form__login > div {
  flex: 1;
}

.create-form__login > div:first-child {
  margin-right: 10px;
}

.create-form__login > div > input:focus {
  background-color: #ffffff;
}

.create-form > div:last-child {
  margin-right: 0;
}

.modal-form-group > .delete__user {
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.modal-form-group > .delete__user:hover {
  color: #d72b3f;
}

.add-more-button {
  padding: 10px 30px;
  color: var(--blue);
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
}

.add-more-button:hover .add-more-button__text {
  text-decoration: underline;
}

.plus--icon {
  cursor: pointer;
  display: inline-flex;
  border: 2px solid var(--blue);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: space-around;
  font-weight: bold;
  font-size: 15px;
  padding-left: 1px;
  text-decoration: none !important;
}

.inputError {
  border-color: #d72b3f;
}

.inputPristine {
  background-color: #eeeeee;
}

.error-text {
  font-size: 11px;
  color: #d72b3f;
}

.italic {
  font-style: italic;
}

.hoverDanger {
  background-color: #ffdcdc !important;
}

</style>



// WEBPACK FOOTER //
// CreateUsersForm.vue?76e0c082